import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { QueryEntity } from '@datorama/akita';
import { sortBy } from 'lodash';
import { map } from 'rxjs';

import { PurchaseOrdersState, PurchaseOrdersStore } from './purchase-orders.store';

@Injectable({ providedIn: 'root' })
export class PurchaseOrdersQuery extends QueryEntity<PurchaseOrdersState> {
  $selectAll = toSignal(this.selectAll(), { requireSync: true });

  selectSortedByPONumber$ = this.selectAll().pipe(
    map((data) => sortBy(data, (purchaseOrder) => purchaseOrder.po_number?.toLowerCase()))
  );

  $selectAllSorted = toSignal(this.selectSortedByPONumber$, { requireSync: true });

  protected store: PurchaseOrdersStore;

  constructor() {
    const store = inject(PurchaseOrdersStore);

    super(store);

    this.store = store;
  }
}
